export function normalizeResponse(data) {
    if (Array.isArray(data)) {
        return data[0] || null; // return first object or null if empty
    }
    return data || null; // return object or null if undefined
}
